export default __webpack_public_path__ + "static/media/chat_fillled.15b373d0.svg";